const agreementConstants = {
  GET_AGREEMENTS: "GET_AGREEMENTS",
  GET_AGREEMENTS_SUCCESS: "GET_AGREEMENTS_SUCCESS",
  GET_AGREEMENTS_FAILURE: "GET_AGREEMENTS_FAILURE",
}

export default agreementConstants;
